module.exports = __webpack_public_path__ + "img/0775a59.jpg";